import React from "react";

import {
  AccordionGroup,
  Column,
  Columns,
  Heading,
  Section,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import { Accordion, Markdown } from "@origin-digital/style-guide";

import content from "./content.json";

export const FAQSection: React.FC = () => (
  <Section>
    <Columns collapseBelow="xl" space="none">
      <Column width="1/12" />
      <Column>
        <Stack space={["xlarge", "xxlarge"]}>
          <Heading variant="h2" align={["left", "center"]}>
            {content.heading}
          </Heading>
          <AccordionGroup>
            {content.accordion.map((accordionContent) => (
              <Accordion
                key={accordionContent.heading}
                label={accordionContent.heading}
              >
                <Stack space={["medium", "large"]}>
                  {accordionContent.body.map((paragraph, key) => (
                    <Text key={key}>
                      <Markdown markdown>{paragraph}</Markdown>
                    </Text>
                  ))}
                </Stack>
              </Accordion>
            ))}
          </AccordionGroup>
        </Stack>
      </Column>
      <Column width="1/12" />
    </Columns>
  </Section>
);
